import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
	colors: {
		primary: "#05001A",
		secondary: "#FAF9F7",
		gold: "linear-gradient(135deg, #735727, #95753c, #bc9a60, #bea776, #c8b489, #d4bb90, #d6c79c, #ad9669)",
		background: "#FAF9F7",
		text: "#05001A",
		textInverted: "#FAF9F7",
	},
	fonts: {
		primary: "Montserrat", // Fonte secundária
		secondary: "Figtree", // Fonte primária
	},
	breakpoints: {
		xs: "576px",
		sm: "768px",
		md: "1024px",
		lg: "1366px",
		xlg: "1920px",
	},
	typeScale: {
		xs: {
			100: "1rem",
			150: "1.2rem",
			200: "1.3rem",
			300: "1.4rem",
			350: "1.6rem",
			400: "1.8rem",
			500: "2rem",
			600: "2.4rem",
		},
		sm: {
			100: "1rem",
			150: "1.2rem",
			200: "1.4rem",
			300: "1.6rem",
			350: "1.8rem",
			400: "2.4rem",
			500: "3.2rem",
			600: "4.8rem",
		},
		lg: {
			100: "1.2rem",
			150: "1.4rem",
			200: "1.6rem",
			300: "1.8rem",
			350: "2.4rem",
			400: "3.2rem",
			500: "4.8rem",
			600: "5.6rem",
		},
	},
};
